import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AmazingTimePickerModule } from '@jonijnm/amazing-time-picker';

import { DatehandlerService } from '@library/common/datehandler';
import { MaterialsModule } from '@library/common/materials';

import { PipesModule, TotalDualVolumePipe, TotalDualWeightPipe, TotalPipe } from '@library/core/pipes';
import { CurrencySelectorModule } from '@library/modules/currency-selector';
import { ErrorsModule } from '@library/modules/errors';
import { AttachmentModule } from '@library/modules/attachment';
import { InfoModule } from '@library/modules/info';

import { ShipmentComponent } from './shipment.component';

import { BillingPartyComponent } from './billing-party/billing-party.component';
import { ShipperBillingPartyComponent } from './billing-party/shipper-billing-party.component';
import { ConsigneeBillingPartyComponent } from './billing-party/consignee-billing-party.component';
import { TypeComponent } from './type/type.component';
import { DatesComponent } from './dates/dates.component';
import { CalculatorComponent, CalculatorItemComponent } from './calculator';
import { ReferencesComponent } from './references/references.component';
import { TradeshowComponent } from './tradeshow/tradeshow.component';
import { RisksComponent } from './risks/risks.component';
import { DescriptionComponent } from './description/description.component';
import { CustomsComponent } from './customs/customs.component';
import { AttachmentsComponent } from './attachments/attachments.component';
import { CodComponent } from './cod/cod.component';
import { AccessorialsComponent } from './accessorials/accessorials.component';
import { SummaryComponent } from './summary/summary.component';
import { ContainersComponent } from './containers/containers.component';
import { CalculatorItemsComponent } from './calculator/calculator-items.component';

import { SummaryLinkDirective } from './summary/summary-link.directive';
import { ExpandedDirective } from './expanded.directive';

@NgModule({
   declarations: [
      ShipmentComponent,
      ShipperBillingPartyComponent,
      ConsigneeBillingPartyComponent,
      BillingPartyComponent,
      TypeComponent,
      DatesComponent,
      CalculatorComponent,
      CalculatorItemComponent,
      ReferencesComponent,
      TradeshowComponent,
      RisksComponent,
      DescriptionComponent,
      CustomsComponent,
      AttachmentsComponent,
      CodComponent,
      AccessorialsComponent,
      SummaryComponent,
      ContainersComponent,
      CalculatorItemsComponent,

      SummaryLinkDirective,
      ExpandedDirective,
   ],
   imports: [
      CommonModule,
      RouterModule,

      FormsModule, ReactiveFormsModule,

      MaterialsModule,

      PipesModule,
      CurrencySelectorModule,
      ErrorsModule,

      AmazingTimePickerModule,

      AttachmentModule,
      InfoModule,
   ],
   providers: [
      DatehandlerService,
      TotalPipe,
      TotalDualWeightPipe,
      TotalDualVolumePipe,
   ],
   exports: [
      ShipmentComponent,
      SummaryComponent,
   ]
})
export class ShipmentModule { }
